module.exports = __webpack_public_path__ + "img/timerPlaceholder@2x.587a2c3b.png";